"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clarityColorPalette = void 0;
var _colorOptions = require("../colorOptions");
var clarityColorPalette = exports.clarityColorPalette = {
  navBackground: _colorOptions.imColors.primary600,
  navBackgroundSelected: _colorOptions.imColors.gray100,
  navIndicator: _colorOptions.imColors.gray25,
  onNavBackground: _colorOptions.imColors.white,
  onNavBackgroundSelected: _colorOptions.imColors.gray700,
  primary: _colorOptions.imColors.primary600,
  surfaceContainerLow: _colorOptions.imColors.primary50
};